<template>
  <div class="container">
    <Panel>
      <template #header>
        <p class="font-bold">
          {{ $t('nav.equipmentType') }}
        </p>
      </template>
      <div class="card_details ">
        <div class="card_body">
          <ul class="list-none pl-0 pl-md-4">
            <li v-if="!isMobile && chosenEquipmentTypes && chosenEquipmentTypes.length > 0" class="flex">
              <label
                for="type"
                class="required-input col-4"
              >{{ $t('entity.equipmentType.field.type') }}</label>
              <label
                for="quantity"
                class="required-input col-4"
              >{{ $t('entity.equipmentType.field.quantity') }}</label>
            </li>
            <li class="flex align-items-center md:align-items-end" v-for="(chosenEquipmentType,index) in chosenEquipmentTypes" :key="chosenEquipmentType?.equipmentTypeDto?.id">
              <div class="col-10 md:col-8 block md:flex p-0">
                <div class="type col-12 md:col-6">
                  <label
                    v-if="isMobile"
                    for="type"
                    class="required-input my-2"
                  >{{ $t('entity.equipmentType.field.type') }}</label>
                  <Dropdown
                    :id="'type-' + index"
                    v-model="chosenEquipmentTypes[index].equipmentTypeDto"
                    :options="equipmentTypes"
                    :option-label="(value) => $i18n.locale === 'fr' ? value.frenchWording : value.englishWording"
                    :placeholder="$t('entity.equipmentType.field.placeholderType')"
                    :class="{'invalid-input': v$.chosenEquipmentTypes.$each.$response.$errors[index].equipmentTypeDto.length > 0}"
                    class="w-full"
                    required
                    :disabled="isReadOnly"
                  />
                </div>
                <div class="quantity col-12 md:col-6">
                  <label
                    v-if="isMobile"
                    for="quantity"
                    class="required-input my-2"
                  >{{ $t('entity.equipmentType.field.quantity') }}</label>
                  <InputText
                    id="quantity"
                    v-model="chosenEquipmentTypes[index].quantity"
                    :class="{'invalid-input': v$.chosenEquipmentTypes.$each.$response.$errors[index].quantity.length > 0 }"
                    type="text"
                    :placeholder="$t('entity.equipmentType.field.placeholderQuantity')"
                    class="w-full"
                    :disabled="isReadOnly"
                  />
                </div>
              </div>
              <div class="col-2 text-center md:text-left md:col-4 mt-3 md:mt-0">
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger mx-1"
                  :title="$t('action.crud.delete')"
                  @click="deleteEquipmentType(chosenEquipmentType)"
                  v-if="!isReadOnly"
                />
              </div>
            </li>
          </ul>
          <div class="text-center">
            <Button
              v-if="!isReadOnly"
              class="p-button-rounded p-button-outlined"
              @click="addEquipmentType()">{{ $t('action.add') }}</Button>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>

import {reactive} from "vue";
import useEquipmentTypeFilter from "@/composables/filters/useEquipmentTypeFilter";
import {useVuelidate} from "@vuelidate/core";
import {minValue, required} from "@/i18n/i18nValidators";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Panel from "primevue/panel";
import Button from "primevue/button";
import EquipmentTypeElem from "@/models/EquipmentTypeElem";
import {helpers} from "@vuelidate/validators";

export default {
  name: 'EquipmentTypesField',
  components: { Panel, Dropdown, InputText, Button},
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** @type {EquipmentTypeDto[]}*/
      equipmentTypes: [],
      isLoading: false
    }
  },
  validations() {
    return {
      chosenEquipmentTypes: {
        $each: helpers.forEach({
          equipmentTypeDto: { required },
          quantity: { required, minValue: minValue(1) }
        })
      }
    }
  },
  setup(){
    const equipmentTypeFilter = reactive(useEquipmentTypeFilter());
    return {
      equipmentTypeFilter: equipmentTypeFilter,
      v$: useVuelidate()
    }
  },
  mounted() {
    this.getEquipmentTypes();
    if (this.chosenEquipmentTypes.length === 0) {
      this.addEquipmentType();
    }
  },
  computed: {
    chosenEquipmentTypes: {
      get() {
        return this.modelValue
      }
    },
    isMobile() {
      return window.innerWidth < 576;
    }
  },
  methods: {
    async getEquipmentTypes() {
      this.isLoading = true;
      try {
        const { content } = await this.$equipmentTypeService.fetchEquipmentTypesPagingAndSorting(this.equipmentTypeFilter.getQueryParams());
        this.equipmentTypes = content;
      } catch (e) {
        console.error(e);
        this.$emitter.emit('toast', { severity: 'error', message: 'error.global' });
      } finally {
        this.isLoading = false;
      }
    },
    addEquipmentType() {
      this.chosenEquipmentTypes.push(new EquipmentTypeElem({
        equipmentTypeDto: null,
        quantity: 1
      }));
      this.v$.$reset();
    },
    deleteEquipmentType(equipmentType) {
      this.chosenEquipmentTypes.splice(this.chosenEquipmentTypes.indexOf(equipmentType), 1);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
